import React, { useState, useEffect, useContext } from "react";
import PasswordToggle from "./PasswordToggle";
import { PaymentNachaContext } from "../contexts/PaymentNachaContext";
import { CarrierContext } from "../contexts/CarrierContext";
import creditCardType from "credit-card-type";
import ReactDOMServer from "react-dom/server";
import { dompurifyInput, dompurifyHtml } from "../utils/sanitizeInput";

const CardForm = ({
  showCardTab,
  isEnableCredit,
  isEnableDebit,
  enableDebitCheck,
  card,
  allowedCreditCardTypes,
  allowedDebitCardTypes,
  cardErrors,
  setCard,
  setCardErrors,
  totalAmountDue,
  payOtherAmount,
  showTotalAmt,
  cms,
  setShowSubmitBtn,
  cardFormValidate,
  /*setNachaAuthMessage,*/
}) => {
  const [currentDate, setCurrentDate] = useState("");
  const [updatedNachaContent, setUpdatedNachaContent] = useState("");
  const [isVisibleCardFormDown, setIsVisibleCardFormDown] = useState(false);
  const [isVisibleCardBtnContinue, setIsVisibleCardBtnContinue] =
    useState(false);
  const {
    getNachaContent,
    nachaContent,
    setNachaContent,
    nachaMainHeading,
    nachaTermsConditions,
    nachaESign,
    nachaCarrierName,
    nachaBillingFreq,
    nachaContentSubHeading,
  } = useContext(PaymentNachaContext);
  const carrierContxt = useContext(CarrierContext);
  const urlCarrier = carrierContxt.hasOwnProperty("carrier")
    ? carrierContxt.carrier
    : null;

  useEffect(() => {
    const date = new Date();
    const formattedDate = date.toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    }); // 'en-GB' formats as DD/MM/YYYY
    setCurrentDate(formattedDate);
    setIsVisibleCardBtnContinue(true);
  }, []);

  /* Mask Card number */
  const [shownCardNumber, setShownCardNumber] = useState(""); // The value shown in the input field
  const [hiddenCardNumber, setHiddenCardNumber] = useState(""); // The raw card number

  const [shownReEnterCardNumber, setShownReEnterCardNumber] = useState(""); // The value shown in the input field
  const [hiddenReEnterCardNumber, setHiddenReEnterCardNumber] = useState(""); // The raw card number

  const showWithoutXsCardNumber = () => {
    // Set the input field value to the hidden (raw) card number when focused
    setShownCardNumber(hiddenCardNumber);
  };

  const hideWithXsCardNumber = () => {
    if (shownCardNumber !== "") {
      // Mask the input value by replacing with 'X's
      const maskedValue = "X".repeat(shownCardNumber.length);
      setHiddenCardNumber(shownCardNumber); // Store the raw card number in hidden state
      setShownCardNumber(maskedValue); // Show the masked value in the input field
    }
  };
  /*  Reneter card number mask */
  const showWithoutXsReEnterCardNumber = () => {
    // Set the input field value to the hidden (raw) card number when focused
    setShownReEnterCardNumber(hiddenReEnterCardNumber);
  };

  const hideWithXsReEnterCardNumber = () => {
    if (shownReEnterCardNumber !== "") {
      // Mask the input value by replacing with 'X's
      const maskedValue = "X".repeat(shownReEnterCardNumber.length);
      setHiddenReEnterCardNumber(shownReEnterCardNumber); // Store the raw card number in hidden state
      setShownReEnterCardNumber(maskedValue); // Show the masked value in the input field
    }
  };
  /* Mask Card number */
  const handleCardDetails = (e) => {
    let { name, value } = e.target;

    //Sanitize input to prevent XSS attacks
    value = dompurifyInput(value);

    // Remove spaces in expiry date using a regular expression
    if (name === "expiry") {
      // Remove non-numeric characters from phone number (if needed)
      value = e.target.value.replace(/\s+/g, "");
    }
    if (name === "phoneNumber") {
      value = formatPhone(value);
    }
    setCard({ ...card, [name]: value });
    setCardErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
    // Get the card type based on the number
    if (name === "cardNumber") {
      const cardType = creditCardType(value);

      if (cardType.length > 0) {
        //Check whether credit card type allowed
        let isCardTypeAllowed = "";
        let cardTypesAllowed = "";
        if (
          !enableDebitCheck &&
          allowedCreditCardTypes &&
          typeof allowedCreditCardTypes === "string"
        ) {
          cardTypesAllowed = allowedCreditCardTypes;
          isCardTypeAllowed = allowedCreditCardTypes
            .split(",")
            .map((type) => type.toLowerCase())
            .includes(cardType[0].type.toLowerCase());
        }
        //Check whether debit card type allowed
        if (
          enableDebitCheck &&
          allowedDebitCardTypes &&
          typeof allowedDebitCardTypes === "string"
        ) {
          cardTypesAllowed = allowedDebitCardTypes;
          isCardTypeAllowed = allowedDebitCardTypes
            .split(",")
            .map((type) => type.toLowerCase())
            .includes(cardType[0].type.toLowerCase());
        }
        if (isCardTypeAllowed) {
          setCard((prevCard) => ({
            ...prevCard,
            cardTypeSelect: cardType[0].type,
          }));
          setCardErrors((prevErrors) => ({
            ...prevErrors,
            cardTypeSelect: "",
          }));
        } else {
          setCardErrors((prevErrors) => ({
            ...prevErrors,
            cardTypeSelect:
              cms.card_type_allowed_label1 +
              " " +
              cardTypesAllowed +
              " " +
              cms.card_type_allowed_label2,
          }));
        }
      } else {
        setCard((prevCard) => ({
          ...prevCard,
          cardTypeSelect: "",
        }));
      }
      setShownCardNumber(value);
    }
    if (name === "reEnterCardNumber") {
      setShownReEnterCardNumber(value);
    }
  };
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setCard((prevValues) => ({
      ...prevValues,
      [name]: checked,
    }));
    setCardErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };
  // Function to return the correct image based on card type
  const getCardImage = () => {
    switch (card?.cardTypeSelect) {
      case "visa":
        return `${process.env.PUBLIC_URL}/images/icons/Payment/visa.svg`;
      case "mastercard":
        return `${process.env.PUBLIC_URL}/images/icons/Payment/mastercard.svg`;
      case "american-express":
        return `${process.env.PUBLIC_URL}/images/icons/Payment/american_express.svg`;
      case "discover":
        return `${process.env.PUBLIC_URL}/images/icons/Payment/discover_card.svg`;
      default:
        return null;
    }
  };
  /* const replaceNachaPlaceholders = () => {
    if (nachaContent) {
      let accountLast4Digits = "";
      if (showCardTab) {
        accountLast4Digits = card?.cardNumber
          ? card.cardNumber.toString().slice(-4)
          : "";
      } else if (showEftTab) {
        accountLast4Digits = form?.accountNumber
          ? form.accountNumber.toString().slice(-4)
          : "";
      }

      const paymentAmount = showTotalAmt
        ? totalAmountDue
        : payOtherAmount
        ? payOtherAmount
        : "";

      const updatedContent = nachaContent
        .replace("@CURRENT_DATE", currentDate)
        .replace("@TOTAL_AMOUNT_DUE", paymentAmount)
        .replace("@LAST_FOUR_DIGIT_OF_BANK_ACCOUNT", accountLast4Digits)
        .replace("@PAYMENT_DATE", currentDate)
        .replace("@CARRIER_NAME", nachaCarrierName)
        .replace("@BILL_FREQUENCY", nachaBillingFreq)
        .replace("@SCHEDULED_DATE", currentDate);

      //console.log(updatedContent); // Check the updated content
      setNachaContent(updatedContent); // Update the state with the new content
    }
  };*/
  //Format card phone number
  const formatPhone = (value) => {
    /* let newPhone = "";

    // Remove invalid characters (non-numeric)
    const phoneNum = value.replace(/[^0-9]/g, "");

    // Format the phone number
    for (let i = 0; i < phoneNum.length; i++) {
      if (i === 3 || i === 6) {
        newPhone += "-";
      }
      newPhone += phoneNum[i];
    }

    return newPhone;*/
    // Remove all non-digit characters (for validation)
    const digits = value.replace(/\D/g, "");

    // Format the phone number as (XXX) XXX-XXXX
    let formattedValue = "";
    if (digits.length > 0) {
      formattedValue = `(${digits.slice(0, 3)}`;
    }
    if (digits.length > 3) {
      formattedValue += `) ${digits.slice(3, 6)}`;
    }
    if (digits.length > 6) {
      formattedValue += `-${digits.slice(6, 10)}`;
    }
    return formattedValue;
  };
  const formatAmount = (value) => {
    if (value !== null && value !== undefined) {
      return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    }
    return "0.00";
  };
  useEffect(() => {
    if (nachaContent && showCardTab) {
      const accountLast4Digits = card?.cardNumber
        ? card.cardNumber.toString().slice(-4)
        : "@LAST_FOUR_DIGIT_OF_PAYMENT_CARD";
      const paymentAmount = showTotalAmt
        ? totalAmountDue
        : payOtherAmount
          ? payOtherAmount
          : "@PAYMENT_AMOUNT";
      const updatedContent = nachaContent
        .replace(/@CURRENT_DATE/g, currentDate)
        .replace(/@PAYMENT_AMOUNT/g, "$" + formatAmount(paymentAmount))
        .replace(/@LAST_FOUR_DIGIT_OF_PAYMENT_CARD/g, accountLast4Digits)
        .replace(/@PAYMENT_DATE/g, currentDate)
        .replace(/@CARRIER_NAME/g, nachaCarrierName)
        .replace(/@BILL_FREQUENCY/g, nachaBillingFreq)
        .replace(/@SCHEDULED/g, currentDate);
      setUpdatedNachaContent(updatedContent);
      if (
        accountLast4Digits !== "@LAST_FOUR_DIGIT_OF_PAYMENT_CARD" &&
        paymentAmount !== "@PAYMENT_AMOUNT"
      ) {
        const footerContent = (
          <div>
            <div className="px-3 mt-4">
              <h4 className="fw-semibold">{nachaMainHeading}</h4>

              <div
                dangerouslySetInnerHTML={{
                  __html:
                    dompurifyHtml(updatedNachaContent) ||
                    dompurifyHtml(nachaContent),
                }}
              />

              <div>
                <div className="col-12 d-flex">
                  <div className="col-xl-8 col-8 mt-2">
                    <input
                      type="checkbox"
                      id="agreeterms"
                      name="termsConditions"
                      required
                      defaultChecked={card.termsConditions}
                      disabled
                    />
                    <label
                      htmlFor="agreeterms"
                      className="form-label fw-semibold grey-heading"
                    >
                      {nachaTermsConditions}{" "}
                      <span className="text-danger">*</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-dialogs text-center">
              <div id="liveAlertPlaceholder"></div>
            </div>
            <div className="col-12 d-flex">
              <div className="mt-2 checkbox-sml">
                <input
                  type="checkbox"
                  id="eSign"
                  name="eSign"
                  required
                  defaultChecked={card.eSign}
                  disabled
                />
                <label htmlFor="eSign">
                  <p>
                    {nachaESign}
                    <span className="text-danger">*</span>
                  </p>
                </label>
              </div>
            </div>
            <div className="px-3 mt-4">
              <p>{nachaContentSubHeading}</p>
            </div>
          </div>
        );

        // Convert the JSX content to HTML string using ReactDOMServer.renderToString
        const footerContentHtml = ReactDOMServer.renderToString(footerContent);
        //setNachaAuthMessage(footerContentHtml);
        sessionStorage.setItem("nacha_" + urlCarrier, footerContentHtml);
      }
    }
  }, [
    nachaContent,
    currentDate,
    setNachaContent,
    updatedNachaContent,
    card.cardNumber,
    showTotalAmt,
    totalAmountDue,
    payOtherAmount,
    nachaCarrierName,
    nachaBillingFreq,
    urlCarrier,
    showCardTab,
    card,
    nachaMainHeading,
    nachaESign,
    nachaContentSubHeading,
    nachaTermsConditions,
  ]);
  /*useEffect(() => {
    const footerContent = (
      <footer className="pb-4 mt-4">
        <div className="px-3 mt-4">
          <h4 className="fw-semibold">{nachaMainHeading}</h4>

          <div
            dangerouslySetInnerHTML={{
              __html: updatedNachaContent || nachaContent,
            }}
          />

          <div>
            <div className="col-12 d-flex">
              <div className="col-xl-4 col-4 mt-2">
                <input
                  type="checkbox"
                  id="agreeterms"
                  name="termsConditions"
                  required
                  defaultChecked={card.termsConditions}
                  disabled
                />
                <label
                  htmlFor="agreeterms"
                  className="form-label fw-semibold grey-heading"
                >
                  {nachaTermsConditions} <span className="text-danger">*</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-dialogs text-center">
          <div id="liveAlertPlaceholder"></div>
        </div>
        <div className="col-12 d-flex">
          <div className="mt-2 checkbox-sml">
            <input
              type="checkbox"
              id="eSign"
              name="eSign"
              required
              defaultChecked={card.eSign}
              disabled
            />
            <label htmlFor="eSign">
              <p> {nachaESign}</p>
            </label>
          </div>
        </div>
        <div className="px-3 mt-4">
          <p>{nachaContentSubHeading}</p>
        </div>
      </footer>
    );

    // Convert the JSX content to HTML string using ReactDOMServer.renderToString
    const footerContentHtml = ReactDOMServer.renderToString(footerContent);
    setNachaAuthMessage(footerContentHtml);
  }, [
    card,
    updatedNachaContent,
    nachaContent,
    nachaMainHeading,
    nachaESign,
    nachaContentSubHeading,
    nachaTermsConditions,
    setNachaAuthMessage,
  ]);*/

  const handleContinueClick = (event) => {
    event.preventDefault();
    if (cardFormValidate()) {
      setIsVisibleCardFormDown(true); // Show the div when the button is clicked
      setShowSubmitBtn(true);
      setIsVisibleCardBtnContinue(false);
    }
    // Focus the footer to ensure it is read by NVDA
    setTimeout(() => {
      const footerElement = document.getElementById("payment-term-cond");
      if (footerElement) {
        footerElement.focus();
      }
    }, 0);
    return false;
  };

  return (
    <>
      {(isEnableCredit || isEnableDebit) && (
        <>
          <div
            className={`tab-pane fade ${showCardTab ? "show active" : ""}`}
            id="card"
            role="tabpanel"
            aria-labelledby="card-tab"
            tabIndex={0}
          >
            <div className="d-md-block d-xl-block">
              {enableDebitCheck ? (
                  <div className="help-text-ccd" id="help-text-ccd" tabIndex="0">
                    <p>{cms.label_dbt_help_text_para1}</p>
                    <ul className="square-items mini">
                      <li>{cms.label_dbt_help_text_line1}</li>
                      <li>{cms.label_dbt_help_text_line2}</li>
                      <li>{cms.label_dbt_help_text_line3}</li>
                    </ul>
                  </div>
              ) : (
                  <div className="help-text-dbt" id="help-text-dbt" tabIndex="0">
                    <p>{cms.label_ccd_help_text_para1}</p>
                    <ul className="square-items mini">
                      <li>{cms.label_ccd_help_text_line1}</li>
                      <li>{cms.label_ccd_help_text_line2}</li>
                      <li>{cms.label_ccd_help_text_line3}</li>
                    </ul>
                  </div>
              )}
              <div className="mb-2">
                <div className="d-xl-flex d-md-flex d-sm-block">
                  <div className="col-xl-6 col-md-6 col px-2">
                    <div className="form-floating mb-2 border-bottom position-relative">
                      {/*Enter Card Number*/}
                      <input
                        type="text"
                        className="form-control"
                        id="cardnumber"
                        name="cardNumber"
                        value={shownCardNumber}
                        onFocus={showWithoutXsCardNumber} // When focused, show the raw card number
                        onBlur={hideWithXsCardNumber} // When blurred, mask with 'X's
                        required={showCardTab}
                        pattern="\d{16}"
                        onChange={handleCardDetails}
                        placeholder={cms.label_pmt_card_number}
                        maxLength="16"
                      />
                      <i
                        className={`me-2 fe fe-info fe-11 position-absolute grey-icons mt-1 ${getCardImage() ? "align-middle" : ""
                          } hover-text ${urlCarrier === "bcbsaz" ? "navy-icon" : ""}`}
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                      >
                        {/* Tooltip*/}
                        <div className="tooltip-text" id="top">
                            <img
                              src={
                                urlCarrier === "bcbsaz"
                                  ? `${process.env.PUBLIC_URL}/images/illustrations/Credirnumber.svg`
                                  : `${process.env.PUBLIC_URL}/images/illustrations/Credirnumber.svg`
                              }
                              className="mw-90 tooltip-card-img"
                              alt="Card-Number"
                            />
                        </div>
                        {/* Tooltip End*/}
                      </i>
                      {getCardImage() && (
                        <span className="input-group-append">
                          <img
                            src={getCardImage()}
                            className="me-2 position-absolute"
                            width={30}
                            height={20}
                            alt="Payment-Method"
                          />
                        </span>
                      )}

                      <label htmlFor="" className="form-label">
                        {cms.label_pmt_card_number}{" "}
                        <span className="text-danger">*</span>
                      </label>
                    </div>
                    {cardErrors.cardNumber && (
                      <p id="payments-validation-error">
                        {cardErrors.cardNumber}
                      </p>
                    )}
                    {cardErrors.cardTypeSelect && (
                      <div id="payments-validation-error">
                        {cardErrors.cardTypeSelect}
                      </div>
                    )}
                  </div>
                  <div className="col-xl-6 col-md-6 px-2 ">
                    <div className="form-floating mb-2 border-bottom position-relative ">
                      {/*RE-Enter Card Number*/}
                      <input
                        type="text"
                        className="form-control"
                        id="cardreenter"
                        placeholder={cms.label_pmt_reenter_card_number}
                        required={showCardTab}
                        name="reEnterCardNumber"
                        value={shownReEnterCardNumber}
                        onFocus={showWithoutXsReEnterCardNumber} // When focused, show the raw card number
                        onBlur={hideWithXsReEnterCardNumber} // When blurred, mask with 'X's
                        onChange={handleCardDetails}
                        maxLength="16"
                      />
                      <span className="input-group-append">
                        <img
                          src={
                            urlCarrier === "bcbsaz"
                              ? `${process.env.PUBLIC_URL}/images/icons/Payment/card-number-bcbsaz.svg`
                              : `${process.env.PUBLIC_URL}/images/icons/Payment/card-number.svg`
                          }
                          className="me-2 position-absolute"
                          width={17}
                          height={17}
                          alt="Card-Number"
                        />
                      </span>
                      <label htmlFor="" className="form-label">
                        {cms.label_pmt_reenter_card_number}{" "}
                        <span className="text-danger">*</span>
                      </label>
                    </div>
                    {cardErrors.reEnterCardNumber && (
                      <div id="payments-validation-error">
                        {cardErrors.reEnterCardNumber}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="mb-2">
                <div className="d-xl-flex d-md-flex d-sm-block">
                  {/* <div className="col-xl-6 col-md-6 px-2">
                    <div className="form-floating mb-2 border-bottom position-relative">
                      {/*Select Card Type*/}
                  {/*    <select
                        className="floating-select"
                        required
                        name="cardTypeSelect"
                        value={card.cardTypeSelect}
                        onChange={handleCardDetails}
                      >
                        <option></option>
                        {!enableDebitCheck &&
                          allowedCreditCardTypes &&
                          typeof allowedCreditCardTypes === "string" &&
                          allowedCreditCardTypes
                            .split(",")
                            .map((cardType, index) => (
                              <option key={index} value={cardType}>
                                {cardType}
                              </option>
                            ))}
                        {enableDebitCheck &&
                          allowedDebitCardTypes &&
                          typeof allowedDebitCardTypes === "string" &&
                          allowedDebitCardTypes
                            .split(",")
                            .map((dbtcardType, index) => (
                              <option key={index} value={dbtcardType}>
                                {dbtcardType}
                              </option>
                            ))}
                      </select>
                      <label htmlFor="cardTypeSelect" className="form-label">
                        {cms.label_pmt_card_type}
                        <span className="text-danger">*</span>
                      </label>
                      {cardErrors.cardTypeSelect && (
                        <div style={{ color: "red", fontSize: "10px" }}>
                          {cardErrors.cardTypeSelect}
                        </div>
                      )}
                    </div>
                  </div>*/}

                  <div className="col-xl-6 col-md-6 col px-2">
                    <div className="form-floating mb-2 border-bottom position-relative">
                      <input
                        type="text"
                        className="form-control"
                        id="Accountname"
                        placeholder=""
                        name="cardAccountName"
                        value={card.cardAccountName}
                        onChange={handleCardDetails}
                        required={showCardTab}
                      />
                      <span className="input-group-append">
                        <img
                          src={
                            urlCarrier === "bcbsaz"
                              ? `${process.env.PUBLIC_URL}/images/icons/Payment/account-name-bcbsaz.svg`
                              : `${process.env.PUBLIC_URL}/images/icons/Payment/account-name.svg`
                          }
                          className="me-2 position-absolute"
                          width={17}
                          height={17}
                          alt="Account-Name"
                        />
                      </span>
                      <label htmlFor="Accountname" className="form-label">
                        {cms.label_pmt_account_name}{" "}
                        <span className="text-danger">*</span>
                      </label>
                    </div>
                    {cardErrors.cardAccountName && (
                      <div id="payments-validation-error">
                        {cardErrors.cardAccountName}
                      </div>
                    )}
                  </div>
                  <div className="col-xl-6 col-md-6 px-2">
                    {/*<div className="col-12 d-flex">*/}
                    <div className="form-floating mb-2 border-bottom position-relative">
                      <input
                        type="text"
                        className="form-control"
                        id="Phone Number"
                        name="phoneNumber"
                        placeholder={cms.label_pmt_phno}
                        required={showCardTab}
                        value={card?.phoneNumber}
                        onChange={handleCardDetails}
                      />
                      <span className="input-group-append">
                        <img
                          src={
                            urlCarrier === "bcbsaz"
                              ? `${process.env.PUBLIC_URL}/images/icons/Payment/Mobile-bcbsaz.svg`
                              : `${process.env.PUBLIC_URL}/images/icons/Payment/Mobile.svg`
                          }
                          className="me-2 position-absolute"
                          width={17}
                          height={17}
                          alt="Mobile"
                        />
                      </span>
                      <label htmlFor="Phone" className="form-label">
                        {cms.label_pmt_phno}{" "}
                        <span className="text-danger">*</span>
                      </label>
                    </div>
                    {cardErrors.phoneNumber && (
                      <p id="payments-validation-error">
                        {cardErrors.phoneNumber}
                      </p>
                    )}
                    {/*</div>*/}
                  </div>
                </div>
              </div>
              <div className="mb-2">
                <div className="d-xl-flex d-md-flex d-sm-block ">
                  <div className="col-xl-6 col-md-6 px-2 ">
                    <div className="form-floating mb-2 border-bottom position-relative">
                      <input
                        type="text"
                        className="form-control datepicker"
                        id="datepicker"
                        required
                        placeholder={`${cms.label_pmt_expiry_date} (MM/YY)`}
                        name="expiry"
                        value={card.expiry}
                        onChange={handleCardDetails}
                      />
                      <span className="input-group-append">
                        <img
                          src={
                            urlCarrier === "bcbsaz"
                              ? `${process.env.PUBLIC_URL}/images/icons/Payment/calendar-bcbsaz.svg`
                              : `${process.env.PUBLIC_URL}/images/icons/Payment/calendar.svg`
                          }
                          className="me-2 position-absolute"
                          alt="Calendar"
                          width={15}
                          height={15}
                        />
                      </span>
                      <label htmlFor="" className="form-label">
                        {cms.label_pmt_expiry_date} (MM/YY){" "}
                        <span className="text-danger">*</span>
                      </label>
                    </div>
                    {cardErrors.expiry && (
                      <p id="payments-validation-error">
                        {cardErrors.expiry}
                      </p>
                    )}
                  </div>
                  <div
                    className={`${enableDebitCheck
                      ? "col-xl-3 col-md-3"
                      : "col-xl-6 col-md-6"
                      } col px-2`}
                  >
                    <div className="form-floating mb-2 border-bottom position-relative">
                      <PasswordToggle
                        id="password"
                        name="cvv"
                        placeholder="CVV"
                        btnClass=""
                        onInputChange={handleCardDetails}
                        cvv={card.cvv}
                        required={showCardTab}
                        urlCarrier={urlCarrier}
                      ></PasswordToggle>
                      {/* <input
                                    type="password"
                                    className="form-control"
                                    id="password"
                                    name="password"
                                    placeholder="password"
                                    value={cardCVV}
                                    onChange={(ev) =>
                                      setcardCVV(ev.target.value)
                                    }
                                  />*/}

                      <i
                        className={`fe fe-info fe-11 position-absolute grey-icons mt-1 align-middle hover-text cvv-i ${
                          urlCarrier === "bcbsaz" ? "navy-icon" : ""
                        }`}
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                      >
                        {/* Tooltip*/}
                        <div className="tooltip-text" id="top">
                          <div className="indicator" />
                          <div className="tool-list">
                            <img
                              src={
                                urlCarrier === "bcbsaz"
                                  ? `${process.env.PUBLIC_URL}/images/icons/Payment/CVV.svg`
                                  : `${process.env.PUBLIC_URL}/images/icons/Payment/CVV.svg`
                              }
                              className="mw-90"
                              alt="CVV"
                            />
                          </div>
                        </div>
                        {/* Tooltip End*/}
                      </i>
                      <label htmlFor="password" className="form-label">
                        {cms.label_pmt_cvv}{" "}
                        <span className="text-danger">*</span>
                      </label>
                    </div>
                    {cardErrors.cvv && (
                      <p id="payments-validation-error">
                        {cardErrors.cvv}
                      </p>
                    )}
                  </div>
                  {enableDebitCheck && (

                    <div className="col-xl-6 col-md-6 col px-2 mt-4" id="class-debit-check">
                      {/*mt-2*/}
                      {/*TO DO: HANDLE THIS CHECKBOX*/}
                      <input
                        type="checkbox"
                        defaultChecked={true}
                        id="debitCheck"
                        name="debitCheck"
                        className={urlCarrier !== "bcbsaz" ? "form-control" : ""}
                        required=""
                      />
                      <label
                        htmlFor="checkbox"
                        className="form-label fw-semibold grey-heading"
                      >
                        {cms.label_pmt_is_it_debit_card}{" "}
                        <span className="text-danger">*</span>
                      </label>
                    </div>
                  )}
                </div>
              </div>
              <div className="mb-2">
                <div className="d-xl-flex d-md-flex d-sm-block ">
                  {/*<div className="col-xl-6 col-md-6 col px-2">
                    <div className="form-floating mb-2 border-bottom position-relative">
                      <select
                        className="floating-select"
                        required
                        name="accountType"
                        value={card.accountType}
                        onChange={handleCardDetails} //TO DO: add acc use
                      >
                        <option />
                        <option value={"PERSONAL"}>Personal</option>
                        <option value={"BUSINESS"}>Business</option>
                      </select>
                      <label htmlFor="accountType" className="form-label">
                        Account Type
                        <span className="text-danger">*</span>
                      </label>
                    </div>
                    {cardErrors.accountType && (
                      <p style={{ color: "red", fontSize: "10px" }}>
                        {cardErrors.accountType}
                      </p>
                    )}
                  </div>*/}
                  <div className="col-xl-6 col-md-6 px-2">
                    <div className="form-floating mb-2 border-bottom position-relative">
                      <input
                        type="text"
                        className="form-control"
                        id="Billing"
                        name="cardBillingAddress1"
                        placeholder={cms.label_pmt_billing_addr1}
                        required={showCardTab}
                        value={card.cardBillingAddress1}
                        onChange={handleCardDetails}
                        maxLength="55"
                      />
                      <span className="input-group-append">
                        <img
                          src={
                            urlCarrier === "bcbsaz"
                              ? `${process.env.PUBLIC_URL}/images/icons/Payment/map-pin-bcbsaz.svg`
                              : `${process.env.PUBLIC_URL}/images/icons/Payment/map-pin.svg`
                          }
                          className="me-2 position-absolute"
                          alt="Billing-Address1"
                          width={17}
                          height={17}
                        />
                      </span>
                      <label htmlFor="" className="form-label">
                        {cms.label_pmt_billing_addr1}
                        <span className="text-danger">*</span>
                      </label>
                    </div>
                    {cardErrors.cardBillingAddress1 && (
                      <p id="payments-validation-error">
                        {cardErrors.cardBillingAddress1}
                      </p>
                    )}
                  </div>
                  <div className="col-xl-6 col-md-6 px-2">
                    <div className="form-floating mb-2 border-bottom position-relative no-feedback">
                      <input
                        type="text"
                        className="form-control"
                        id="Billing2"
                        name="cardBillingAddress2"
                        placeholder={cms.label_pmt_billing_addr2}
                        value={card.cardBillingAddress2}
                        onChange={handleCardDetails}
                        maxLength="55"
                      />
                      <span className="input-group-append">
                        <img
                          src={
                            urlCarrier === "bcbsaz"
                              ? `${process.env.PUBLIC_URL}/images/icons/Payment/map-pin-bcbsaz.svg`
                              : `${process.env.PUBLIC_URL}/images/icons/Payment/map-pin.svg`
                          }
                          className="me-2 position-absolute"
                          alt="Billing-Address2"
                          width={17}
                          height={17}
                        />
                      </span>
                      <label htmlFor="" className="form-label">
                        {cms.label_pmt_billing_addr2}
                      </label>
                    </div>
                    {cardErrors.cardBillingAddress2 && (
                      <p id="payments-validation-error">
                        {cardErrors.cardBillingAddress2}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="mb-2">
                <div className="d-xl-flex d-md-flex d-sm-block ">
                  <div className="col-xl-6 col-md-6 px-2">
                    <div className="form-floating mb-2 border-bottom position-relative no-feedback">
                      <input
                        type="text"
                        className="form-control"
                        id="Email"
                        name="email"
                        placeholder="Email"
                        value={card.email}
                        onChange={handleCardDetails} //TO DO: add email
                        maxLength="80"
                      />
                      <span className="input-group-append">
                        <img
                          src={
                            urlCarrier === "bcbsaz"
                              ? `${process.env.PUBLIC_URL}/images/icons/mail-bcbsaz.svg`
                              : `${process.env.PUBLIC_URL}/images/icons/mail.svg`
                          }
                          className="me-2 position-absolute"
                          alt="Email"
                          width={17}
                          height={17}
                        />
                      </span>
                      <label htmlFor="Email" className="form-label">
                        {cms.label_pmt_email}
                      </label>
                    </div>
                    {cardErrors.email && (
                      <p id="payments-validation-error">
                        {cardErrors.email}
                      </p>
                    )}
                  </div>
                  <div className="col-xl-6 col-md-6 px-2">
                    <div className="form-floating mb-2 border-bottom position-relative">
                      <select
                        className="floating-select"
                        name="state"
                        value={card.state}
                        onChange={handleCardDetails}
                        aria-label={cms.label_pmt_state}
                      >
                        <option value=""></option>
                        <option value="AL">Alabama</option>
                        <option value="AK">Alaska</option>
                        <option value="AZ">Arizona</option>
                        <option value="AR">Arkansas</option>
                        <option value="CA">California</option>
                        <option value="CO">Colorado</option>
                        <option value="CT">Connecticut</option>
                        <option value="DE">Delaware</option>
                        <option value="DC">District Of Columbia</option>
                        <option value="FL">Florida</option>
                        <option value="GA">Georgia</option>
                        <option value="HI">Hawaii</option>
                        <option value="ID">Idaho</option>
                        <option value="IL">Illinois</option>
                        <option value="IN">Indiana</option>
                        <option value="IA">Iowa</option>
                        <option value="KS">Kansas</option>
                        <option value="KY">Kentucky</option>
                        <option value="LA">Louisiana</option>
                        <option value="ME">Maine</option>
                        <option value="MD">Maryland</option>
                        <option value="MA">Massachusetts</option>
                        <option value="MI">Michigan</option>
                        <option value="MN">Minnesota</option>
                        <option value="MS">Mississippi</option>
                        <option value="MO">Missouri</option>
                        <option value="MT">Montana</option>
                        <option value="NE">Nebraska</option>
                        <option value="NV">Nevada</option>
                        <option value="NH">New Hampshire</option>
                        <option value="NJ">New Jersey</option>
                        <option value="NM">New Mexico</option>
                        <option value="NY">New York</option>
                        <option value="NC">North Carolina</option>
                        <option value="ND">North Dakota</option>
                        <option value="OH">Ohio</option>
                        <option value="OK">Oklahoma</option>
                        <option value="OR">Oregon</option>
                        <option value="PA">Pennsylvania</option>
                        <option value="RI">Rhode Island</option>
                        <option value="SC">South Carolina</option>
                        <option value="SD">South Dakota</option>
                        <option value="TN">Tennessee</option>
                        <option value="TX">Texas</option>
                        <option value="UT">Utah</option>
                        <option value="VT">Vermont</option>
                        <option value="VA">Virginia</option>
                        <option value="WA">Washington</option>
                        <option value="WV">West Virginia</option>
                        <option value="WI">Wisconsin</option>
                        <option value="WY">Wyoming</option>
                      </select>
                      <label htmlFor="state" className="form-label">
                        {cms.label_pmt_state}
                        <span className="text-danger">*</span>
                      </label>
                    </div>
                    {cardErrors.state && (
                      <p id="payments-validation-error">
                        {cardErrors.state}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="mb-2">
                <div className="d-xl-flex d-md-flex d-sm-block ">
                  <div className="col-xl-6 col-md-6 px-2">
                    {/*<div className="col-12 d-flex">
                      <div className="col-xl-6 col-md-6">*/}
                    <div className="form-floating mb-2 border-bottom position-relative">
                      <input
                        type="text"
                        className="form-control"
                        id="City"
                        name="city"
                        placeholder="City"
                        required={showCardTab}
                        value={card.city}
                        onChange={handleCardDetails}
                      />
                      <span className="input-group-append">
                        <img
                          src={
                            urlCarrier === "bcbsaz"
                              ? `${process.env.PUBLIC_URL}/images/icons/Payment/map-pin-bcbsaz.svg`
                              : `${process.env.PUBLIC_URL}/images/icons/Payment/map-pin.svg`
                          }
                          className="me-2 position-absolute"
                          alt="City"
                          width={17}
                          height={17}
                        />
                      </span>
                      <label htmlFor="City" className="form-label">
                        {cms.label_pmt_city}{" "}
                        <span className="text-danger">*</span>
                      </label>
                    </div>
                    {cardErrors.city && (
                      <p id="payments-validation-error">
                        {cardErrors.city}
                      </p>
                    )}
                    {/*</div>*/}

                    {/*</div>*/}
                  </div>
                  <div className="col-xl-6 col-md-6 px-2">
                    <div className="form-floating mb-2 border-bottom position-relative">
                      <input
                        type="number"
                        className="form-control"
                        id="Zip"
                        name="zip"
                        placeholder="Zip"
                        required={showCardTab}
                        value={card.zip}
                        onChange={handleCardDetails}
                      />
                      <span className="input-group-append">
                        <img
                          src={
                            urlCarrier === "bcbsaz"
                              ? `${process.env.PUBLIC_URL}/images/icons/Payment/map-bcbsaz.svg`
                              : `${process.env.PUBLIC_URL}/images/icons/Payment/map.svg`
                          }
                          className="me-2 position-absolute"
                          alt="Zip"
                          width={17}
                          height={17}
                        />
                      </span>
                      <label htmlFor="Zip" className="form-label">
                        {cms.label_pmt_zip}{" "}
                        <span className="text-danger">*</span>
                      </label>
                    </div>
                    {cardErrors.zip && (
                      <p id="payments-validation-error">
                        {cardErrors.zip}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              {/*<div className="mb-2">
                <div className="d-xl-flex d-md-flex d-sm-block ">

                </div>
              </div>*/}
            </div>
          </div>
          {isVisibleCardBtnContinue && showCardTab && (
            <button
              type="button"
              className="btn mt-2 btn-primary btn-lg button"
              onClick={handleContinueClick}
            >
              {cms.label_continue}
            </button>
          )}

          {isVisibleCardFormDown && showCardTab && (
            <footer className="pb-4 mt-4" tabIndex="0" id="payment-term-cond" aria-live="assertive">
              <div className="px-3 mt-4">
                <h4 className="fw-semibold nacha-heading">{nachaMainHeading}</h4>

                <div
                  dangerouslySetInnerHTML={{
                    __html:
                      dompurifyHtml(updatedNachaContent) ||
                      dompurifyHtml(nachaContent),
                  }}
                />
                {nachaContent && (
                  <div>
                    <div className="col-12 mt-2" tabIndex="0">
                      <div className="d-flex align-items-start flex-nowrap gap-2">
                        <input
                          type="checkbox"
                          id="agreeterms"
                          name="termsConditions"
                          required
                          checked={card.termsConditions}
                          onChange={handleCheckboxChange}
                          style={{ marginTop: "3px", flexShrink: 0 }}
                        />
                        <label
                          htmlFor="agreeterms"
                          className="form-label fw-semibold grey-heading mb-0"
                        >
                          {nachaTermsConditions}{" "}
                          <span className="text-danger">*</span>
                        </label>
                      </div>
                      {cardErrors.termsConditions && (
                        <p id="payments-validation-error" className="mt-1 ms-0">
                          {cardErrors.termsConditions}
                        </p>
                      )}
                    </div>
                  </div>
                )}
              </div>
              <div className="modal-dialogs text-center">
                <div id="liveAlertPlaceholder"></div>
              </div>
              {nachaContent && (
                <div className="col-12 d-flex" tabIndex="0">
                  <div className="mt-2 checkbox-sml">
                    <input
                      type="checkbox"
                      id="eSign"
                      name="eSign"
                      required
                      checked={card.eSign}
                      onChange={handleCheckboxChange}
                    />
                    <label htmlFor="eSign">
                      <p>
                        {nachaESign}
                        <span className="text-danger">*</span>
                      </p>
                    </label>
                    {cardErrors.eSign && (
                      <p id="payments-validation-error">
                        {cardErrors.eSign}
                      </p>
                    )}
                  </div>
                </div>
              )}
              <div className="px-3 mt-4">
                <p>{nachaContentSubHeading}</p>
              </div>
            </footer>
          )}
        </>
      )}
    </>
  );
};
export default CardForm;
